import {
  Autocomplete,
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  SwipeableDrawer,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TeamTabContentStyles from "../TeamTabContent/TeamTabContent.styles";
import CustomButton from "../../../../../../global/components/CustomButton/CustomButton";
import customTableStyles from "../../../../../../global/components/CustomTable/customTable.styles";
import {
  DataGridPro,
  GridColDef,
  GridRenderCellParams,
  GridToolbarColumnsButton,
  GridToolbarContainer,
} from "@mui/x-data-grid-pro";
import { applyLicenseKey } from "../../../../../../utils/License";
import CustomPageHeaderStyles from "../../../../../../global/components/CustomPageHeader/CustomPageHeader.styles";
import CloseIcon from "@mui/icons-material/Close";
import {
  addDeveloper,
  addProject,
  getDeveloper,
  getProject,
} from "../../../../../Project/components/stepper/StepperService";
import { log } from "console";
import paginationStyles from "../../../../../../global/components/CustomTable/Pagination.styles";
import AddProjectMatadata from "../AddProjectMetaData/AddProjectMatadata";
import SearchIcon from "@mui/icons-material/Search";
import customInputStyles from "../../../../../../global/components/CustomInput/CustomInput.styles";
import LeadPersonalDetailsStyles from "../../../../../AllLeads/components/stepper copy/Personal Details/LeadPersonalDetails.styles";

interface Errors {
  developerName?: string;
  developerLevel?: string;
  parentHierarchy?: string;
  projectName?: string;
}
const ProjectList = () => {
  const customTableClasses = customTableStyles;
  const classes = TeamTabContentStyles;
  const [stageDrawer, setStageDrawer] = useState(false);
  const [projectData, setProjectData] = useState<any>([]);
  const [metaData, setMetaData] = useState<any>({});
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [search, setSearch] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [developerData, setDeveloperData] = useState<any>({});
  const [errors, setErrors] = useState<Errors>({});
  const [addProjectData, setAddProjectData] = useState<any>({});
  const [devloperDrawerData, setDevloperDrawerData] = useState<any>("");
  const [allDevloperData, setAllDevloperData] = useState<any>([]);
  const formattedOptions = allDevloperData.map((dev: any) => ({
    label: dev.developer_name,
    value: dev._id,
  }));

  useEffect(() => {
    applyLicenseKey();
  }, []);

  useEffect(() => {
    getAllProjectData();
  }, []);

  const closeDrawer = () => {
    setStageDrawer(false);
    setDeveloperData({
      developerName: "", 
      isOrganization: 0, 
    });
  };
  const handlePageSizeChange = (event: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: event.target.value,
      page: 0,
    });
  };

  const getAllProjectData = async () => {
    const projectData = await getProject();
    setProjectData(projectData.data);
    const getDevData = await await getDeveloper();
    setAllDevloperData(getDevData.data);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{ width: "100%", justifyContent: "space-between" }}
      >
        <Box>
          <TextField
            id="outlined-search"
type="search"
            placeholder="Search"
            variant="standard"
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            sx={{
              width: "100%",
              fontSize: "12px",
            }}
            autoFocus={isSearchFocused}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onFocus={() => setIsSearchFocused(true)}
            onBlur={() => setIsSearchFocused(false)}
          />
        </Box>
        <Box sx={{ justifyContent: "end" }}>
          <GridToolbarColumnsButton />
        </Box>
      </GridToolbarContainer>
    );
  }

  const handleSearch = async (newValue: string) => {
    setSearch(newValue);
  };

  const columns: GridColDef[] = [
    {
      headerName: "Developer Name",
      field: "developer_name",
      filterable: true,
      minWidth: 300,
      flex: 1,
    },
    {
      headerName: "Project Name",
      field: "project_name",
      minWidth: 300,
      filterable: true,
      flex: 1,
    },
  ];
  const handleSubmit = async () => {
    try {
      if (developerData.isOrganization === 1) {
        if (!addProjectData.projectName) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            projectName: "Project Name is required",
          }));
          return;
        }

        const body = {
          developerId: devloperDrawerData.hierarchyLevel.value,
          project_name: addProjectData.projectName,
        };
        const addPro = await addProject(body);
      } else {
        if (!developerData.developerName) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            developerName: "Developer Name is required",
          }));
          return;
        }
        const addDev = await addDeveloper({
          developer_name: developerData.developerName,
        });
        closeDrawer()
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  return (
    <Box sx={classes.teamTabContentWrapper}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container mb={2}>
            <Grid item xs={10}></Grid>
            <Grid item xs={2}>
              <CustomButton
                buttonType="primaryBtn"
                label="Create"
                onClick={() => setStageDrawer(true)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid item xs={12} sx={customTableStyles.tableGridPart}>
            <DataGridPro
              columns={columns}
              rows={projectData}
              getRowId={(row) => row._id}
              rowHeight={95}
              density="compact"
              localeText={{ noRowsLabel: "No data found" }}
              sx={customTableClasses.gridRow}
              rowsLoadingMode="server"
              slots={{
                toolbar: CustomToolbar,
              }}
            />
          </Grid>
          <Box sx={paginationStyles.footer}>
            <Box sx={paginationStyles.footerRight}>
              <div style={{ marginRight: "8px" }}>Rows per page</div>

              <FormControl size="small" sx={{ border: "none" }}>
                <Select
                  value={paginationModel.pageSize}
                  onChange={handlePageSizeChange}
                  label="Page Size"
                  sx={{
                    fontSize: "11px",
                    border: "none",
                    minWidth: "60px",
                  }}
                >
                  <MenuItem value={10} sx={paginationStyles.menuItem}>
                    10
                  </MenuItem>
                  <MenuItem value={25} sx={paginationStyles.menuItem}>
                    25
                  </MenuItem>
                  <MenuItem value={50} sx={paginationStyles.menuItem}>
                    50
                  </MenuItem>
                  <MenuItem value={100} sx={paginationStyles.menuItem}>
                    100
                  </MenuItem>
                  <MenuItem value={200} sx={paginationStyles.menuItem}>
                    200
                  </MenuItem>
                </Select>
              </FormControl>

              <Pagination
                count={Math.ceil(metaData?.total / paginationModel.pageSize)}
                page={paginationModel.page + 1}
                onChange={(event, value) => {
                  setPaginationModel({
                    ...paginationModel,
                    page: value - 1,
                  });
                }}
                size="small"
                siblingCount={1}
                boundaryCount={1}
                // sx={classes.font}
              />
            </Box>
          </Box>
        </Grid>
        <SwipeableDrawer
          anchor="right"
          style={{ zIndex: 1300 }}
          open={stageDrawer}
          onClose={() => closeDrawer()}
          onOpen={() => setStageDrawer(true)}
        >
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => closeDrawer()}
            style={{ position: "absolute", top: 10, right: 10 }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ width: 750 }} role="presentation">
            <Typography sx={CustomPageHeaderStyles.heading} p={2}>
              Create
            </Typography>
            <Divider />

            <Box p={2} sx={{ height: "calc(100vh - 123px)" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={developerData.isOrganization === 1}
                        onChange={(e: any) => {
                          setDeveloperData({
                            id: developerData.id ? developerData.id : "",
                            isOrganization: e.target.checked ? 1 : 0,
                          });
                        }}
                        name="departmentTeamSwitch"
                        color="primary"
                      />
                    }
                    label={
                      developerData.isOrganization === 1
                        ? "Project"
                        : "Developer"
                    }
                  />
                </Grid>

                {developerData.isOrganization === 1 ? (
                  <>
                    <Grid item xs={12} lg={6}>
                      <Box>
                        <InputLabel sx={customInputStyles.nameField}>
                          Developer Name
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          value={devloperDrawerData?.hierarchyLevel ?? ""}
                          onChange={(
                            event: any,
                            newValue: { label: string; value: number } | null
                          ) => {
                            setDevloperDrawerData({
                              ...devloperDrawerData,
                              hierarchyLevel: newValue,
                            });
                            if (errors.developerLevel) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                hierarchyLevel: "",
                              }));
                            }
                          }}
                          options={formattedOptions}
                          sx={{
                            ...customTableStyles.autocompleteStyle,
                            zIndex: "1300",
                          }}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select" />
                          )}
                          renderOption={(props, option) => (
                            <li {...props} style={{ fontSize: "12px" }}>
                              {option.label}
                            </li>
                          )}
                        />
                        {errors.developerLevel && (
                          <InputLabel sx={{ color: "red", fontSize: "12px" }}>
                            {errors.developerLevel}
                          </InputLabel>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <Box>
                        <InputLabel sx={customInputStyles.nameField}>
                          Project Name
                        </InputLabel>

                        <TextField
                          fullWidth
                          // value={developerData}
                          placeholder="Project Name"
                          sx={LeadPersonalDetailsStyles.textField}
                          id="fullWidth"
                          onChange={(e: any) => {
                            setAddProjectData({
                              ...addProjectData,
                              projectName: e.target.value,
                            });
                            if (errors.projectName) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                projectName: "",
                              }));
                            }
                          }}
                        />
                        {errors.projectName && (
                          <InputLabel sx={{ color: "red", fontSize: "12px" }}>
                            {errors.projectName}
                          </InputLabel>
                        )}
                      </Box>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} lg={6}>
                    <Box>
                      <InputLabel sx={customInputStyles.nameField}>
                        Developer Name
                      </InputLabel>

                      <TextField
                        fullWidth
                        value={developerData.developerName ?? ""}
                        placeholder="DeveloperData Name"
                        sx={LeadPersonalDetailsStyles.textField}
                        id="fullWidth"
                        onChange={(e: any) => {
                          setDeveloperData({
                            ...developerData,
                            developerName: e.target.value,
                          });
                          if (errors.developerName) {
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              developerName: "",
                            }));
                          }
                        }}
                      />
                      {errors.developerName && (
                        <InputLabel sx={{ color: "red", fontSize: "12px" }}>
                          {errors.developerName}
                        </InputLabel>
                      )}
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
            <Divider />
            <Grid item xs={12} sx={LeadPersonalDetailsStyles.buttonFooter}>
              <Box>
                <CustomButton
                  label="Cancel"
                  onClick={() => closeDrawer()}
                  buttonType="default"
                  customClasses={LeadPersonalDetailsStyles.periousNextstyle}
                />
              </Box>
              <Box>
                <CustomButton
                  label="Submit"
                  onClick={() => handleSubmit()}
                  buttonType="primaryBtn"
                  customClasses={LeadPersonalDetailsStyles.periousNextstyle}
                />
              </Box>
            </Grid>
          </Box>
        </SwipeableDrawer>
      </Grid>
    </Box>
  );
};

export default ProjectList;
